// import { getInstance, useFsTheme } from '@fs/utils';
import React, {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from 'react';
import type { FsUserContextProps, UserInfo } from './model';

const FsUserContext = createContext<FsUserContextProps | undefined>(undefined);

export const useUserInfo = () => {
  const context = useContext(FsUserContext);
  if (!context) {
    throw new Error('useFsUser must be used within a FsUserContextProvider');
  }
  return context;
};

interface FsUserContextProviderProps {
  children: ReactNode;
}

const FsUserContextProvider: React.FC<FsUserContextProviderProps> = ({
  children,
}) => {
  // const { language } = useFsTheme();
  // const { instance } = getInstance({ language });
  const [userInfo, setUserInfo] = useState<Partial<UserInfo> | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const getUserInfo = useCallback(() => {
    setIsLoading(true);
    // Promise.all([
    //   instance.get('/v1/panel/getprofilesbyuserid'),
    //   instance.get('/v1/panel/getpostsbyuserid'),
    // ])
    //   .then(([userInfoRes, userPostRes]) => {
    //     setUserInfo({
    //       ...userInfoRes?.data?.data,
    //       userPostId: userPostRes?.data?.data,
    //     });
    //   })
    //   .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    const path = window.location.pathname;
    const isLoginRoute = path === '/login' || path.endsWith('/login');
    if (!isLoginRoute) {
      getUserInfo();
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      userInfo,
      setUserInfo,
      refreshUserInfo: getUserInfo,
      isLoading,
    }),
    [userInfo, getUserInfo, isLoading]
  );

  return (
    <FsUserContext.Provider value={contextValue}>
      {children}
    </FsUserContext.Provider>
  );
};

export default FsUserContextProvider;
